module.exports = __webpack_public_path__ + "img/picon3.80c9dbe6.png";